// src/redux/slices/alquileresSlice.ts
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getAlquileres } from 'services/servicioGet';
import { AlquilerBase } from 'utils/models/types';

interface AlquileresState {
  alquileres: AlquilerBase[];
  loadingAlq: boolean;
  errorAlq: string | null;
}

// Estado inicial del slice
const initialState: AlquileresState = {
  alquileres: [],
  loadingAlq: false,
  errorAlq: null,
};

// Thunk para obtener los alquileres
export const fetchAlquileres = createAsyncThunk<AlquilerBase[], void, { rejectValue: string }>(
  'alquileres/fetchAlquileres',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getAlquileres();
      return response;
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : String(error));
    }
  }
);

// Slice de alquileres
const alquileresSlice = createSlice({
  name: 'alquileres',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchAlquileres.pending, state => {
        state.loadingAlq = true;
        state.errorAlq = null;
      })
      .addCase(fetchAlquileres.fulfilled, (state, action) => {
        state.alquileres = action.payload;
        state.loadingAlq = false;
      })
      .addCase(fetchAlquileres.rejected, (state, action) => {
        state.loadingAlq = false;
        state.errorAlq = action.payload as string;
      });
  },
});

export default alquileresSlice.reducer;
